import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import lodash from 'lodash';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {
  setSearchingMode,
  setLoading,
  fetchPackageClient,
  removeOtpData,
  goToPage,
  saveSelectedCountriesUsedInSearch,
  openModal,
  closeModal,
  saveToHistory,
  setSearchedPackages,
  setSelectedFromSalePageFlag,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  setOtpPopupData,
  setSelectedAbroadPackage,
  abroadRetrieveCustomerData,
  fetchPackageBusinessIndividualClient,
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
  setOtpPhone,
  getAddonsPackage,
  setSaleActiveStep,
} from '../cellcomAbroadBlockSlice';

import {Row, Col, Container, Button} from 'reactstrap';
import {
  searchPackageItems,
  lobbyTabsEnum,
  searchParametersEnum,
  pages,
  popupReasonEnum,
  customerTypeEnum,
  otpValidationPopupContent,
  saleActiveStep,
} from '../cellcomAbroadVariables';
import {getFilteredCountryList, isSuitableDates, formatDatesToDifferentFormats} from '../cellcomAbroadUtilities';
import SelectCountriesComponent from './SelectCountriesComponent';
import SelectDatesComponent from './SelectDatesComponent';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../../utilities/hooks/useClearStateResetFlag';
import {gaChangeAccountBusinessIndividual} from '../gaReports';
import {dwhPackageSearchActivation, getDwhParams} from '../dwhReports';
import {resetAuth, resetLoginData} from '../../../../utilities/authentication/authenticationSlice';
import {OrganizationType} from '../Shared/Models/AbroadPackageModels';
import {setSelfcareSubscriber , resetPage} from '../../../Page/SelfCarePage/SelfCareSlice';
const SearchParametersHolderComponent = (props) => {
  useEffect(() => {
    if (
      props.data.relatedPhoneNumbers?.length > 0 &&
      props.selectedSelfcareSubscriber &&
      props.data.relatedPhoneNumbers.includes(props.selectedSelfcareSubscriber)
    ) {
      setAndValidatePhone(props.selectedSelfcareSubscriber);
    }
  }, [props.selectedSelfcareSubscriber, props.data.relatedPhoneNumbers]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (
          props.data.otpData.isOTPValidated &&
          props.data.selectedCountries?.length > 0 &&
          props.data.dates.selectedStartDate &&
          props.data.dates.selectedEndDate &&
          window.location.hash == '#search_results' &&
          !props.data.selectedAbroadPackage
        ) {
          validateAndStartSearching();
        }
      }
    },
    [props.data.otpData.isOTPValidated],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.data.executePackagesSearch) {
          validateAndStartSearching();
        }
      }
    },
    [props.data.executePackagesSearch],
  );

  useClearStateResetFlag();

  const getSelectedData = (id) => {
    let selectedData;
    switch (id) {
      case searchParametersEnum.COUNTRY:
        selectedData = prepareSelectedCountriesStr();
        break;
      case searchParametersEnum.DATES:
        selectedData = prepareSelectedDatesStr();
        break;
    }
    return selectedData;
  };

  function prepareSelectedCountriesStr() {
    let str = `<span><bdi>${props.data.selectedCountries[0].countryHebName} </bdi></span>`;
    if (props.data.selectedCountries.length - 1 > 0) {
      str += `<span>+</span>
                    <span>${props.data.selectedCountries.length - 1} </span>
                    <span>${props.data.selectedCountries.length - 1 == 1 ? 'יעד' : 'יעדים'}</span>`;
    }

    return str;
  }

  function prepareSelectedDatesStr() {
    return `<span class="startDate">${props.data.dates.selectedStartDate}</span> -
                <span class="endDate">${props.data.dates.selectedEndDate}</span>`;
  }

  const checkForSeparatedMove = () => {
    const selectedPackage = props.data.selectedAbroadPackage;
    if (
      props.data.otpData?.validatedCostumerData?.isSeparatedSale ||
      (props.data.otpData?.validatedCostumerData?.accountTypeIsValid?.item1 == 'Business' &&
        props.data.otpData?.validatedCostumerData?.accountTypeIsValid?.item2 == false)
    ) {
      props.setLoading(true);
      const sendObj = {
        phoneNumber: props.data.otpData.otpPhone,
        socCode: selectedPackage.socCode,
        startDate: props.data.dates.selectedStartDate,
        endDate: props.data.dates.selectedEndDate,
        type: 'Business',
        blockId: props.data.epiStyleInitializationData.businessSocPackageFolderId,
        countries: lodash.map(props.data.selectedCountries, 'countryCode'),
      };

      props.abroadRetrieveCustomerData(sendObj).then((res) => {
        props.setLoading(false);
        const customerData = res.payload.result;
        if (customerData?.isSeparatedSale) {
          if (customerData?.isDefaultSoc && customerData?.isDefaultSoc.length != 0) {
            props.setSelectedAbroadPackage(null);
            props.setOtpPopupData(otpValidationPopupContent.separatedSaleDefaultPackage);
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '2',
            });
          } else if (customerData?.subsriberSurfIsBlocked && selectedPackage.type.toUpperCase().includes('DATA')) {
            if (selectedPackage.isBankOrByUse == 'ByUse') {
              props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedByUse);
            } else {
              props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedBank);
              props.setSelectedAbroadPackage(null);
            }
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '3',
            });
          } else if (customerData?.shadowData?.ban == '-1') {
            props.setSelectedAbroadPackage(null);
            props.setOtpPopupData(otpValidationPopupContent.separatedGeneralError);
            props.openModal(popupReasonEnum.OTP_RESULT);

            props.PlantShadowMemo({
              banId: customerData.shadowData?.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              shadowBan: customerData.shadowData?.ban,
              memoType: '4',
            });
          } else {
            props.PlantMemoBeforePackagePurchase({
              banId: customerData.shadowData.ban,
              soc: selectedPackage.socCode,
              subscriber: props.data.otpData.otpPhone,
              countries: lodash.map(props.data.selectedCountries, 'countryCode'),
              startDate: props.data.dates.selectedStartDate,
              endDate: props.data.dates.selectedEndDate,
            });
            props.context.navigateTo(props.data.epiStyleInitializationData.urlToSeparatedSale);
          }
        } else {
          props.setLoading(true);
          props.goToPage(pages.SALE);
          props.setSaleActiveStep(saleActiveStep.TICKET);
          props.context.navigateTo(props.data.epiStyleInitializationData.urlToSaleBlock);
        }
      });
    } else {
      props.setLoading(true);
      props.goToPage(pages.SALE);
      props.setSaleActiveStep(saleActiveStep.TICKET);
      props.context.navigateTo(props.data.epiStyleInitializationData.urlToSaleBlock);
    }
  };

  async function validateAndStartSearching(start, end, skipValidation) {
    let startDate = start ? start : props.data.dates.datePickerStartJSFormat;
    let endDate = end ? end : props.data.dates.datePickerEndJSFormat;
    let {channel, subscriber, param1, param3, param4, param5, param6, param7} = getDwhParams(props.data);

    if (props.data.selectedCountries.length > 0 && startDate && endDate) {
      //if selected package already exists
      if (!props.data.selectedAbroadPackage) {
        props.setSearchingMode('');
        props.saveToHistory();
        dispatchSearching(startDate, endDate);
      } else {
        const unsupportedCountries =
          props.data.selectedAbroadPackage?.countrySupportedList?.length > 0
            ? getFilteredCountryList(props.data.selectedCountries, props.data.selectedAbroadPackage.countrySupportedList)
            : null;
        const isSuitable = isSuitableDates(props.data.selectedAbroadPackage, startDate, endDate);
        //popup unSupported countries (selected package exists)
        if (unsupportedCountries?.length == props.data.selectedCountries?.length) {
          props.setSearchingMode(searchParametersEnum.COUNTRY);
          props.openModal(popupReasonEnum.ALL_SELECTED_COUNTRIES_ARE_NOT_SUPPORTED_IN_SELECTED_PACKAGE);

          //dwh
          const param2 = 'Countries are not supported for package';
          const message = 'Did not search for package';

          dwhPackageSearchActivation({channel, subscriber, message, param1, param2, param3, param4, param5, param6, param7});

          return false;
        }
        //popup dates (selected package exists)
        if (!isSuitable && !skipValidation) {
          props.setSearchingMode(searchParametersEnum.DATES);
          props.openModal(popupReasonEnum.SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE);
          //dwh
          const param2 = 'Dates are not supported on selected package';
          const message = 'Did not search for package';
          param7 = endDate;
          dwhPackageSearchActivation({channel, subscriber, message, param1, param2, param3, param4, param5, param6, param7});

          return false;
        }
        props.setSearchingMode('');
        props.saveToHistory();
        checkForSeparatedMove();
      }
    } else {
      if (startDate && endDate && props.data.selectedAbroadPackage) {
        const isSuitable = isSuitableDates(props.data.selectedAbroadPackage, startDate, endDate);
        if (!isSuitable && !skipValidation) {
          props.setSearchingMode(searchParametersEnum.DATES);
          props.openModal(popupReasonEnum.SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE);
          if (param5) {
            //dwh
            const param2 = 'Dates are not supported on selected package';
            const message = 'Did not search for package';
            param7 = endDate;
            dwhPackageSearchActivation({channel, subscriber, message, param1, param2, param3, param4, param5, param6, param7});
          }
          return false;
        }
      }
      props.data.selectedCountries?.length == 0
        ? props.setSearchingMode(searchParametersEnum.COUNTRY)
        : props.setSearchingMode(searchParametersEnum.DATES);
    }
  }

  async function dispatchSearching(startDate, endDate) {
    props.closeModal();
    if (props.data.selectedCountries?.length > 0) {
      let blockId, goldBusinessPackagesBlockId, phoneNumber, otpTicketId, orgId;
      if (props.data.epiStyleInitializationData.businessIndividualLobby) {
        goldBusinessPackagesBlockId = props.data.epiStyleInitializationData.goldBusinessSocPackageFolderId;
        blockId = props.data.epiStyleInitializationData.businessSocPackageFolderId;
        phoneNumber = props.data.businessIndividualData.selectedAccountNumber;
      } else {
        blockId =
          props.data.otpData.isOTPValidated && props.data.otpData.validatedCostumerData.accountType == customerTypeEnum.BUSINESS
            ? props.data.epiStyleInitializationData.businessSocPackageFolderId
            : props.data.epiStyleInitializationData.privateSocPackageFolderId;
        phoneNumber = props.data?.otpData?.isOTPValidated && props?.data?.otpData?.otpPhone ? props.data.otpData.otpPhone : null;
      }
      let searchRequest = {
        CountryCodeList: lodash.map(props.data.selectedCountries, 'countryCode'),
        DateStart: startDate
          ? formatDatesToDifferentFormats(startDate).formattedUI
          : formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedUI,
        DateEnd: endDate
          ? formatDatesToDifferentFormats(endDate).formattedUI
          : formatDatesToDifferentFormats(props.data.dates.datePickerEndJSFormat).formattedUI,
        BlockId: blockId,
        PhoneNumber: phoneNumber,
      };

      props.setSearchingMode('');

      if (props.data.epiStyleInitializationData.businessIndividualLobby) {
        searchRequest.OrgId = props.portalsBlock.privateCompanyList?.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId;
        searchRequest.GoldBusinessPackagesBlockId = goldBusinessPackagesBlockId;
        await props.fetchPackageBusinessIndividualClient(searchRequest);
      } else {
        searchRequest.otpTicketId =
          props.data?.otpData?.isOTPValidated && props?.data?.otpData?.step1Ticket ? props.data.otpData.step1Ticket : null;
        // await setAndValidatePhone(phoneNumber);
        await props.fetchPackageClient(searchRequest);
      }

      props.saveSelectedCountriesUsedInSearch(props.data.selectedCountries);
      if (props.data.abroadPackagesList || window.location.hash == '#search_results') {
        props.saveToHistory();
      } else {
        props.saveToHistory('search_results');
      }
    } else {
      props.setSearchingMode(searchParametersEnum.COUNTRY);
    }
  }

  const gaAndContinue = () => {
    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gtag4({
          event: 'CellcomAbroad_Step2_ContinueButtonClick',
          step: '2',
          action: 'ContinueButtonClick',
          process_type: 'private',
          funnel_name: '1 - Lobby',
          button: props.data.selectedAbroadPackage ? 'לרכישה' : 'תמצאו לי חבילה ',
        });

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.data.otpData?.validatedCostumerData?.isSeparatedSale) {
          if (!props.data.selectedAbroadPackage) {
            gaEvent(
              gaParams.SEPARATED_SEARCHBUTTON_CLICK.category,
              gaParams.SEPARATED_SEARCHBUTTON_CLICK.eventType,
              gaParams.SEPARATED_SEARCHBUTTON_CLICK.eventParams,
            );
          }
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SEARCH_PACKAGES_BUTTON_IS_CLICKED_BUSINESS.category,
            gaParams.ABROAD_LOBBY_SEARCH_PACKAGES_BUTTON_IS_CLICKED_BUSINESS.eventType,
            gaParams.ABROAD_LOBBY_SEARCH_PACKAGES_BUTTON_IS_CLICKED_BUSINESS.eventParams,
          );
        }
        break;
      default:
        break;
    }
    if (props.data.selectedAbroadPackage && props.organizationType?.value == OrganizationType.IDF) {
      props.openModal(popupReasonEnum.IDF_ORDER);
    } else {
      validateAndStartSearching();
    }
  };
  const disconnectOtp = async () => {
    if (props.data.abroadPackagesList) {
      props.setSearchedPackages(null);
      props.saveToHistory();
    }
    //await props.resetAuth();
    props.resetLoginData();
     props.removeOtpData();
     props.resetPage();
    props.saveToHistory();
  };

  const ifAuthIsVisible = () => {
    if (
      (props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE || props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT) &&
      (((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
        props.data.relatedPhoneNumbersRequestCompleted) ||
        (props.authentication?.loginData?.isOtpAuthenticated && props.data.otpData.isOTPValidated) ||
        props.data.isJETAuthentication)
    )
      return true;
    else if (props.data.epiStyleInitializationData.businessIndividualLobby && props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSINDIVIDUAL)
      return true;
    return false;
  };
  const getAuthTitle = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby && !props.data.businessIndividualData.selectedAccountNumber)
      return 'לרכישת החבילה';
    return 'מנוי';
  };

  const getAuthPhoneNumber = () => {
    let phoneNumber;
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      phoneNumber = props.data.businessIndividualData.selectedAccountNumber ? (
        <span className='pr-1 pl-1'>{props.data.businessIndividualData.selectedAccountNumber}</span>
      ) : null;
    } else {
      if (
        ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
          props.data.relatedPhoneNumbers?.length > 1) ||
        (props.data.relatedPhoneNumbers?.length == 1 &&
          !props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber))
      ) {
        phoneNumber = getSelectAccountHtml();
      } else {
        phoneNumber = (
          <span className='pr-1 pl-1'>{props.data.otpData.otpPhone || props.authentication.loginData.userDetails?.contactNumber}</span>
        );
      }
    }
    return phoneNumber;
  };

  const getSelectPlaceHolder = () => {
    if (
      props.data.otpData.otpPhone &&
      props.data?.otpData?.isOTPValidated &&
      props.data.relatedPhoneNumbers.length > 0 &&
      props.data.relatedPhoneNumbers.includes(props.data.otpData.otpPhone)
    ) {
      return props.data.otpData.otpPhone;
    }
    // else if (
    //   props.data.relatedPhoneNumbers.length > 0 &&
    //   props.data.relatedPhoneNumbers.includes(props.authentication.loginData?.userDetails?.contactNumber)
    // ) {
    //   return props.authentication.loginData?.userDetails?.contactNumber;
    // }
    else {
      return 'בחר מנוי';
    }
  };
  const setAndValidatePhone = (phone) => {
    props.setOtpPhone(phone);
    props.setSelfcareSubscriber(phone);
    let JETConnection = false;
    let phoneNumber = phone;
    props.validateCustomerType({JETConnection, phoneNumber});
  };

  const getSelectAccountHtml = () => {
    return (
      <ReactSelect
        getOptionLabel={(option) => option}
        getOptionValue={(option) => option}
        placeholder={getSelectPlaceHolder()}
        value={props.data.relatedPhoneNumbers.filter(
          (option) => option === (props.selectedSelfcareSubscriber || props.data.otpData.otpPhone),
        )}
        name='selected'
        options={props.data.relatedPhoneNumbers}
        onChange={(phone) => setAndValidatePhone(phone)}
      />
    );
  };

  const getAuthLogOutText = () => {
    let logIntext;
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      logIntext = props.data.businessIndividualData.selectedAccountNumber ? 'החלף מנוי' : 'בחר מנוי';
    } else {
      logIntext = 'התנתק';
    }
    return logIntext;
  };

  const changeAccountBusinessIndividual = () => {
    gaChangeAccountBusinessIndividual();
    const params = {
      isSelecting: true,
      removeSelectedAbroadPackage: false,
    };
    props.clearSearchParameters();
    props.setIsSelectingAccountBusinessIndividual(params);
    props.context.navigateTo(props.data.businessIndividualData.selfCareBlockUrl);
  };

  const getClearSearchParametersBtn = () => {
    return (
      <Button color='link' type='button' className='w-100' onClick={() => clearSearchParameters()}>
        נקה חיפוש
      </Button>
    );
  };
  const clearSearchParameters = () => {
    props.clearSearchParameters();
    props.saveToHistory();
    props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
  };

  const checkOpenedPopup = () => {
    if (props.data.isShowPopup && props.data.popupReason == popupReasonEnum.COUNTRY_WARNING_INFO) {
      return true;
    }
    return false;
  };

  return (
    <Container>
      <Row>
        {ifAuthIsVisible() && (
          <Col
            className={`${
              props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated
                ? 'd-flex flex-wrap align-items-center'
                : 'd-block bold'
            } otp-logout w-100  ${
              isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'text-center' : 'text-right'
            } ${checkOpenedPopup() ? '' : 'hight-z-index'}`}>
            <span
              className={`${
                props.authentication?.loginData?.isFullAuthenticated ||
                (props.authentication?.loginData?.isOtpExtendedAuthenticated && props.data.relatedPhoneNumbers?.length > 1)
                  ? 'mb-10'
                  : ''
              }`}>
              {getAuthTitle()}
            </span>
            {getAuthPhoneNumber()}
            {!props.data.isJETAuthentication && (
              <Button
                color='link'
                className={`newPurple ${
                  isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'p-0' : 'pl-0 pr-0'
                } ${
                  (props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
                  props.data.relatedPhoneNumbers?.length > 1
                    ? 'mb-10'
                    : ''
                }`}
                onClick={() =>
                  props.data.epiStyleInitializationData.businessIndividualLobby ? changeAccountBusinessIndividual() : disconnectOtp()
                }>
                {getAuthLogOutText()}
              </Button>
            )}
          </Col>
        )}
      </Row>
      {(isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution) &&
        (props.data.selectedCountries?.length > 0 || props.data.dates.selectedStartDate || props.data.dates.selectedEndDate) && (
          <Row>{getClearSearchParametersBtn()}</Row>
        )}

      <Row>
        {searchPackageItems.map((item, index) => {
          return item.id == 'country' ? (
            <SelectCountriesComponent
              key={index}
              item={item}
              collapse={props.data.searchingMode.searchParameter == item.id}
              selectedData={props.data.selectedCountries.length > 0 ? getSelectedData(item.id) : null}
              selectedCountriesList={props.data.selectedCountries}
              validateAndStartSearching={validateAndStartSearching}
            />
          ) : (
            <SelectDatesComponent
              key={index}
              item={item}
              collapse={props.data.searchingMode.searchParameter == item.id}
              searchMode={props.data.searchingMode}
              selectedData={props.data.dates.selectedStartDate && props.data.dates.selectedEndDate ? getSelectedData(item.id) : null}
              validateAndStartSearching={validateAndStartSearching}
              dispatchSearching={dispatchSearching}
            />
          );
        })}
        <Col
          className={`${
            isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution
              ? 'col-12'
              : 'col-2 pl-0 pr-0 pt-1 d-flex flex-wrap align-items-center search-wrapper-button'
          } ${props.data.selectedAbroadPackage ? '' : 'small-font-for-button'}`}>
          <BtnRightSideText
            isDisplayArrows={true}
            text={props.data.selectedAbroadPackage ? 'לרכישה' : 'תמצאו לי חבילה '}
            onclick={() => gaAndContinue()}
            isBusiness={props.data.epiStyleInitializationData.businessIndividualLobby || props.data.activeLobbyTab == 'businessAccount'}
          />
          {((!isMobile && !props.data.isSmallResolution) || (isTablet && !props.data.isPortrait)) &&
            (props.data.selectedCountries?.length > 0 || props.data.dates.selectedStartDate || props.data.dates.selectedEndDate) && (
              <>{getClearSearchParametersBtn()}</>
            )}
        </Col>
      </Row>
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    portalsBlock: state.portalsBlock,
    authentication: state.authentication,
    organizationType: state.welcomeBlock.organizationState?.organizationType,
    selectedSelfcareSubscriber: state.selfcarePage.selectedSubscriber?.productSubscriberNo,
  };
};

const mapDispatchToProps = {
  setSearchingMode,
  setLoading,
  fetchPackageClient,
  saveSelectedCountriesUsedInSearch,
  removeOtpData,
  goToPage,
  openModal,
  closeModal,
  saveToHistory,
  setSearchedPackages,
  setSelectedFromSalePageFlag,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  setOtpPopupData,
  setSelectedAbroadPackage,
  abroadRetrieveCustomerData,
  fetchPackageBusinessIndividualClient,
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
  resetAuth,
  resetLoginData,
  setOtpPhone,
  setSelfcareSubscriber,
  getAddonsPackage,
  setSaleActiveStep,
  resetPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchParametersHolderComponent);
